export const GA4_EVENT = {
   ADD_SHIPMENT_TEMPLATE: "add_shipment_template",
   PRODUCTS_CHANGE_APPROVAL_STATUS: "products_change_approval_status",
   PRODUCTS_DETAILS_UPDATE: "products_details_update",
   PRODUCTS_DELETED: "products_deleted",
   PRODUCT_LIST_FILTER: "product_list_filter",
   VIEW_PRODUCT_DEALS: "view_product_deals",
   PRODUCT_FILTERED_SEARCH: "product_filtered_search",
   SEARCH_PRODUCT: "search_product",
   OPEN_PRODUCT_FOR_SALE: "open_product_for_sale",
   PRODUCT_LINK_CLICK: "product_link_click",
}
